import React from 'react'
import { H3, P } from '../../../../../AbstractElements'
import { CommonMofiModalTitleType } from '../../../../../Type/Ui-Kits/UiKitsTypes'

const CommonMofiModalTitle: React.FC<CommonMofiModalTitleType> = ({ heading, subHeading, text }) => {
  return (
    <>
      <div className="title-wrapper pb-3 modal-heading">
        <H3 className="theme-name mb-0">
          <span>{heading}</span>
          {subHeading}
        </H3>
        <P>{text}</P>
      </div>
    </>
  )
}

export default CommonMofiModalTitle